import * as React from "react";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Table } from "../../table/table/table.mjs";
import { TableCollapseTrigger } from "../table-collapse-trigger/table-collapse-trigger.mjs";
const TableCollapse = (props) => {
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentName: "TableCollapse", componentProps: props, defaultValueName: "defaultOpenItems", valueName: "openItems", onChangeNames: "onToggle" }, /* @__PURE__ */ React.createElement(TableCollapseInner, { ...props }));
};
const _TableCollapseInner = class _TableCollapseInner extends React.Component {
  constructor(props) {
    super(props);
    this.onToggle = (id) => {
      if (this.openItems.indexOf(id) !== -1) {
        const openItems = [...this.openItems.filter((itemId) => itemId !== id)];
        if (typeof this.props.openItems === "undefined") {
          this.setState({ openItems });
        }
        if (this.props.onToggle) {
          this.props.onToggle(openItems);
        }
        if (this.props.onRowClose) {
          this.props.onRowClose(id);
        }
      } else {
        const openItems = !this.props.multiple ? [id] : [...this.openItems, id];
        if (typeof this.props.openItems === "undefined") {
          this.setState({ openItems });
        }
        if (this.props.onToggle) {
          this.props.onToggle(openItems);
        }
        if (this.props.onRowOpen) {
          this.props.onRowOpen(id);
        }
      }
    };
    this.state = {
      openItems: props.defaultOpenItems || []
    };
  }
  get openItems() {
    return this.props.onToggle && typeof this.props.openItems !== "undefined" ? this.props.openItems : this.state.openItems;
  }
  BEM() {
    const classArray = ["table-collapse"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  rowBEM(props) {
    const classArray = ["table-collapse__row"];
    if (props["data-row-trigger"] || props.rowTrigger) {
      classArray.push("table-collapse__row--trigger");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  }
  contentBEM(props) {
    const classArray = ["table-collapse__content"];
    if (props.id && this.openItems.indexOf(this.parseId(props.id)) !== -1) {
      classArray.push("is-open");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  }
  parseId(id) {
    return id.replace("#", "");
  }
  enhance(children) {
    return React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) {
        return child;
      }
      if (React.isValidElement(child) && child.type === TableCollapseTrigger) {
        return React.cloneElement(child, {
          isActive: this.openItems.indexOf(this.parseId(child.props.url)) !== -1,
          onToggle: this.onToggle
        });
      }
      if (React.isValidElement(child) && (child.props["data-table-collapse"] || child.props.collapsible)) {
        const headless = child.props.collapsible ? { headless: true } : { "data-headless": true };
        return React.cloneElement(child, {
          ...headless,
          className: this.contentBEM(child.props)
        });
      }
      if (React.isValidElement(child)) {
        const rowTrigger = child.props["data-row-trigger"] || child.props.rowTrigger;
        return React.cloneElement(
          child,
          rowTrigger ? {
            children: this.enhance(child.props.children),
            className: this.rowBEM(child.props),
            onClick: () => this.onToggle(this.parseId(rowTrigger))
          } : {
            children: this.enhance(child.props.children)
          }
        );
      }
      return child;
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(Table, { className: this.BEM(), ...this.props }, this.enhance(this.props.children));
  }
};
_TableCollapseInner.defaultProps = {
  multiple: true
};
let TableCollapseInner = _TableCollapseInner;
export {
  TableCollapse,
  TableCollapseInner
};
